import { Table, Typography } from "antd";
import React, { useMemo } from "react";
import dbConnection from "../../../assets/db_connection.png";
import connectionTime from "../../../assets/connectionTime.png";
export default function PgAdminConnection({ selectedConnection }) {
  const { Text } = Typography;

  const dbDetails = useMemo(() => {
    if (!selectedConnection?.connection_string) return null;

    try {
      const cleanedString = selectedConnection.connection_string.replace(
        "psql ",
        "",
      );
      const url = new URL(cleanedString);

      return {
        HostName: url.hostname,
        Port: url.port,
        DatabaseName: url.pathname.replace("/", ""),
        UserName: decodeURIComponent(url.username),
        Password: decodeURIComponent(url.password).replace(/^'|'$/g, ""),        
      };
    } catch {
      return null;
    }
  }, [selectedConnection]);

  const columns = [
    {
      title: "Field",
      dataIndex: "label",
      key: "label",
      width: "40%",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text, record) =>
        record.key === "password" ? (
          <Text.Password copyable={{ text }}>{text}</Text.Password>
        ) : (
          <Text copyable={{ text }} className="font-mono">
            {text}
          </Text>
        ),
    },
  ];

  const data = Object.entries(dbDetails || {}).map(([label, value]) => ({
    key: label,
    label,
    value,
  }));

  return (
    <div>
      <div className="mb-4 text-gray-700 text-sm">
        Please copy and paste the following values in pgAdmin to connect to the
        database.
      </div>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        size="small"
      />

      <div className="mt-4 text-center">
        <img
          src={dbConnection}
          alt="pgAdmin Setup Guide"
          className="rounded-lg border max-h-64 object-contain mx-auto"
        />
      </div>
      <div className="mt-4 text-amber-600 text-sm">
        <strong>Important:</strong> Set the connection timeout to
        <strong> 120 seconds</strong> to allow sufficient time for completing
        AuthNull MFA.
      </div>
      <div className="mt-4 text-center">
        <img
          src={connectionTime}
          alt="pgAdmin Setup Guide"
          className="rounded-lg border max-h-64 object-contain mx-auto"
        />
      </div>
    </div>
  );
}
